const PREVIEW_MAP = {
  // VIDEO TYPES
  'video/mp4': 'video',
  'video/quicktime': 'video',
  'video/webm': 'video',
  'video/x-ms-wmv': 'video',
  'video/mpeg': 'video',
  'video/avi': 'video',
  'video/x-flv': 'video',
  'video/x-m4v': 'video',
  // IMAGE TYPES
  'image/gif': 'image',
  'image/jpeg': 'image',
  'image/png': 'image',
  // DOCUMENT TYPES
  'application/msword': 'document',
  'application/vnd.oasis.opendocument.text': 'document',
  'application/x-iwork-pages-sffpages': 'document',
  'application/vnd.apple.pages': 'document',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'document',
  'application/pdf': 'document',
  'application/zip': 'document',
  'application/x-gzip': 'document',
  'application/x-tar': 'document',
  'applicaion/Java-Archive': 'document',
  'application/x-zip-compressed': 'document',
  'text/vtt': 'document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'document',
  'application/vnd.ms-powerpoint': 'document',
  'application/vnd.oasis.opendocument.presentation': 'document',
  'application/x-iwork-keynote-sffkey': 'document',
  // AUDIO TYPES
  'audio/x-m4a': 'audio',
  'audio/mpeg': 'audio',
  'audio/mp3': 'audio',
  'audio/ogg': 'audio',
  'audio/mp4a-latm': 'audio',
  'audio/wav': 'audio',
  'audio/x-ms-wma': 'audio',
  'audio/flac': 'audio',
};

export default (fileType) => PREVIEW_MAP[fileType];
